<template>
  <div class="home">
      <UserManagement class="marginal" ></UserManagement>
  </div>
</template>

<script>
import UserManagement from '@/components/UserManagement.vue';
export default {
  name: 'UserManagementPage',
  components: {
    UserManagement
  }
}
</script>